/**
 * Reports part B permission keys (docs/contracts/reports.md §5; RP21): dashboards and Ask-your-data (`analytics.*`, plan
 * module `analytics`), the query builder and saved query reports with view / print / export / send (RP6), the footfall
 * KPI (legacy PeopleCounting, menu 267) and franchise exports (menu 316). The API checks the same keys.
 */
export const analyticsPermissions = {
  dashboardView: "analytics.dashboard.view",
  dashboardAuthor: "analytics.dashboard.author",
  dashboardManage: "analytics.dashboard.manage",
  askData: "analytics.ask_data.view",
  aiSettingsView: "analytics.ai_settings.view",
  aiSettingsUpdate: "analytics.ai_settings.update",
  queryRun: "rpt.query.run",
  queryEditSql: "rpt.query.edit_sql",
  queryReportView: "rpt.query_report.view",
  queryReportCreate: "rpt.query_report.create",
  queryReportUpdate: "rpt.query_report.update",
  queryReportDelete: "rpt.query_report.delete",
  queryReportPrint: "rpt.query_report.print",
  queryReportExport: "rpt.query_report.export",
  queryReportSend: "rpt.query_report.send",
  footfallView: "rpt.people_counting.view",
  footfallCreate: "rpt.people_counting.create",
  footfallUpdate: "rpt.people_counting.update",
  footfallDelete: "rpt.people_counting.delete",
  footfallPrint: "rpt.people_counting.print",
  footfallExport: "rpt.people_counting.export",
  footfallImport: "rpt.people_counting.import",
  franchiseView: "rpt.franchise_export.view",
  franchiseCreate: "rpt.franchise_export.create",
  franchiseUpdate: "rpt.franchise_export.update",
  franchiseDelete: "rpt.franchise_export.delete",
  franchiseExport: "rpt.franchise_export.export",
} as const;

/** Plan module of the dashboards and Ask-your-data. The query builder, footfall and franchise exports are core. */
export const analyticsModule = "analytics";

/** Route of the AI settings screen and of OpenRouter's callback (AI5; `Analytics:Ai:OpenRouter:CallbackPath`). */
export const aiSettingsPath = "/reports/ai-settings";
export const openRouterCallbackPath = "/reports/ai-settings/openrouter";

/** Report code of saved query reports in schedules and the inbox (RP14). */
export const queryReportCode = "queryReport";
